import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from 'helpers/css';

const badgeVariants = cva(
  'tw-inline-flex tw-items-center tw-rounded-md tw-border tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold  focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'tw-border-transparent tw-bg-primary tw-text-primary-foreground tw-shadow hover:tw-bg-primary/80',
        secondary:
          'tw-border-transparent tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80',
        destructive:
          'tw-border-transparent tw-bg-destructive tw-text-red-200 tw-shadow hover:tw-bg-destructive/80',
        outline: 'tw-text-foreground',
        success: 'tw-border-transparent tw-bg-green-50 tw-text-green-500 hover:tw-bg-green/80',
        warning: 'tw-border-transparent tw-bg-orange-50 tw-text-orange-500 hover:tw-bg-orange/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
